import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ButtonM, TextDiv } from "../../styles/Common";
import { ReactComponent as IcoPlay } from "../../styles/images/play.svg";
import { ReactComponent as IcoPause } from "../../styles/images/ico_pause.svg";
import MainBanner1 from "../../styles/images/img_main_banner1.png";
import MainBanner2 from "../../styles/images/img_main_banner2.png";
import MainBanner3 from "../../styles/images/img_main_banner3.png";
import MainBanner4 from "../../styles/images/img_main_banner4.png";
import { styled } from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const MainSlide = (props) => {
  const { data } = props;
  // console.log(data);
  const navigate = useNavigate();
  const location = useLocation();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [autoplayMode, setAutoplayMode] = useState(true);

  const [slideIndex, setSlideIndex] = useState(0);
  const [updateCount, setUpdateCount] = useState(0);

  const [count, setCount] = useState(0);
  const [pass, setPass] = useState(true);

  const sliderRef = useRef(null);

  const play = () => {
    setPass(true);
    setAutoplayMode(!autoplayMode);
    sliderRef.current.slickPlay();
  };

  const pause = () => {
    setPass(false);
    setAutoplayMode(!autoplayMode);
    sliderRef.current.slickPause();
  };

  const goToSlide = (index) => {
    sliderRef.current.slickGoTo(index);
  };
  const returnSec = (sec) => {
    if (sec == 0) {
      return false;
    } else {
      return Number(sec + "000");
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: data.summary?.sec == 0 ? false : true,
    autoplaySpeed: returnSec(data.summary?.sec) || 3000,
    // autoplaySpeed: 5000,
    arrows: false,
    initialSlide: 0,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  const handleImageClick = (link) => {
    // 예시: 이미지 클릭 시 `/detail/${index}` 경로를 새 창에서 열기
    window.open(link, "_blank");
  };

  function interval() {
    if (!data.count) return;
    else {
      setCount((prevCount) => prevCount + 1);
    }
  }
  useEffect(() => {
    if (!data.count) return;
    let startInterval;
    if (pass) {
      startInterval = setInterval(interval, 100);
      return () => clearInterval(startInterval);
    } else if (pass == false) {
      clearInterval(startInterval);
    }
  }, [pass, data]);

  useEffect(() => {
    if (data.count == 0) return;
    const num = data.summary?.sec * 10;
    if (num < count) {
      sliderRef.current.slickNext();
    }
  }, [count]);

  useEffect(() => {
    setCount(0);
  }, [currentSlide]);

  return (
    <MainSlideWrap>
      <TextDiv>
        <p>
          <span>뮤포인트</span>의 다양한 제휴사 서비스를 경험해 보세요!
        </p>
      </TextDiv>
      {data.count > 0 && (
        <SlideDiv>
          <StyledSlider ref={sliderRef} {...settings}>
            {data.list.map((li, index) => (
              <div key={index} onClick={() => handleImageClick(li.link)}>
                <img src={li.image} alt="" />
              </div>
            ))}
          </StyledSlider>
          <Paging>
            {/* <div className="progress">
              <div
                className="progress-done"
                style={{ opacity: 1, width: `${count}%` }}
              ></div>
            </div> */}
            {/* <p>{count}</p> */}
            <input
              onChange={(e) => {
                goToSlide(e.target.value);
                setCurrentSlide(Number(e.target.value));
              }}
              value={count}
              type="range"
              min={0}
              max={data.summary?.sec * 10}
              style={{
                background: `linear-gradient( to right, #ffffff ${
                  (count / data.summary?.sec) * 10
                }%, rgba(255, 255, 255, 0.25) ${
                  (count / data.summary?.sec) * 10
                }%)`,
              }}
            />
            {/* <input
              onChange={(e) => {
                goToSlide(e.target.value);
                setCurrentSlide(Number(e.target.value));
              }}
              value={currentSlide}
              type="range"
              min={0}
              max={data.count - 1}
            /> */}
            <p>
              {currentSlide + 1} - {data.count}
            </p>

            {autoplayMode ? (
              <button className="button" onClick={pause}>
                <IcoPause />
              </button>
            ) : (
              <button className="button" onClick={play}>
                <IcoPlay />
              </button>
            )}
            <span></span>
          </Paging>
        </SlideDiv>
      )}
    </MainSlideWrap>
  );
};

export default MainSlide;

const MainSlideWrap = styled.div`
  padding: 2rem;
  width: 100%;
  p {
    color: ${({ theme }) => theme.color.purple_primary};
  }
`;

const SlideDiv = styled.div`
  position: relative;
  width: 100%;
  min-height: 39rem;
  height: auto;
  margin-top: 0.9rem;
  border-radius: 1rem;
  overflow: hidden;
`;

const StyledSlider = styled(Slider)`
  img {
    width: calc(100% - 1px);
    height: 100%;
    border-radius: 1rem;
  }
  .slick-slide div {
    outline: none; // 슬라이드 클릭시 파란선을 제거하기 위해서 작성
  }
  .slick-list {
    overflow: hidden;
  }
`;

const Paging = styled.div`
  /* background-color: #000000; */
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
  input {
    margin-right: 1.4rem;
    height: 1.4rem;
    line-height: 1.4rem;
  }
  p {
    font-size: 1.4rem;
    line-height: normal;
    letter-spacing: -0.42px;
    color: ${({ theme }) => theme.color.white};
  }
  button {
    margin-left: 1.4rem;
    width: 0.9rem;
    height: 1.4rem;
    background-color: transparent;
    svg {
      width: 100%;
      height: 100%;
    }
  }

  input[type="range"] {
    -webkit-appearance: none;
    width: 8rem;
    height: 0.4rem;
    border-radius: 0.4rem;
    background: rgba(255, 255, 255, 0.25);
    accent-color: rgb(255, 255, 255);
  }

  input[type="range"]:focus {
    outline: none;
  }

  input[type="range"]::-webkit-slider-runnable-track {
    width: 100%;
    height: 100%;
    cursor: pointer;
    border-radius: 0.5rem;
  }

  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    border-radius: 1rem;
    width: 1rem;
    height: 1rem;
    margin-top: -0.3rem;
    background: ${({ theme }) => theme.color.white};
    position: relative;
    cursor: pointer;
  }

  .progress {
    width: 8rem;
    height: 0.4rem;
    border-radius: 0.4rem;
    background: rgba(255, 255, 255, 0.25);
    margin-right: 1.4rem;
  }

  .progress-done {
    background: ${({ theme }) => theme.color.white};
    border-radius: 20px;
    height: 100%;
    opacity: 0;
    width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.05s ease;
    color: white;
    position: relative;

    &::after {
      display: block;
      content: "";
      border-radius: 50%;
      width: 1rem;
      height: 1rem;
      background: ${({ theme }) => theme.color.white};
      cursor: pointer;
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      right: 0;
    }
  }
`;
